import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './containers/Home';
import Company from './containers/Pages/Company';
import Services from './containers/Pages/Services';
import Industries from './containers/Pages/Industries';
import Contact from './containers/Pages/Contact';
// import ScrollToTop from './components/ScrollToTop.jsx';

function App() {
  return (
    <div className="App">
      <Router>
  {/* <ScrollToTop/> */}

        <Routes>
          <Route exact path='/' element={<Home />} />
          <Route path='/company' element={<Company />} />
          <Route path='/services' element={<Services />} />
          <Route path='/industries' element={<Industries />} />
          <Route path='/contact' element={<Contact />} />
          
        </Routes>
      </Router>
    </div>
  );
}

export default App;
